import React from "react";
import { CalendarDaysIcon, DumbbellIcon, ListOrderedIcon, GaugeIcon, SlidersHorizontalIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { MockupLink } from "./MockupLink";
import { images } from "../../data/images";
import { OFFER_HASH } from "../../data/links";
const benefits = [{
  label: "40 Weeks",
  icon: CalendarDaysIcon,
  color: "bg-navy"
}, {
  label: "120 Workouts",
  icon: DumbbellIcon,
  color: "bg-green"
}, {
  label: "Sets + Reps",
  icon: ListOrderedIcon,
  color: "bg-rose"
}, {
  label: "RPE",
  icon: GaugeIcon,
  color: "bg-teal"
}, {
  label: "Exercise Adaptations",
  icon: SlidersHorizontalIcon,
  color: "bg-charcoal"
}];
export function Hero() {
  return <header className="w-full bg-white" data-id="element-138" data-mp="32i5o9f45hir6">
      <div className="bg-navy px-4 py-2.5 text-center" data-id="element-139" data-mp="32iywylmo6iby">
        <p className="text-xs font-semibold text-white md:text-sm" data-id="element-140" data-mp="dqcycekowudq">
          <span className="font-extrabold uppercase text-gold" data-id="element-141" data-mp="ds66xzev5ood">Attention:</span> Personal Trainers, Fitness Instructors &amp; Coaches Who Train Pregnant Clients
        </p>
      </div>

      <div className="mx-auto max-w-5xl px-5 pb-14 pt-10 md:pt-12" data-id="element-142" data-mp="2un7komalampj">
        <h1 className="mx-auto max-w-3xl text-center font-display text-2xl font-black uppercase leading-tight tracking-tight text-navy md:text-4xl" data-id="element-143" data-mp="2prij6df0evql">
          The Complete <span className="bg-gold-light px-1.5 text-teal" data-id="element-144" data-mp="2gpspf0xnnkpn">Ready-to-Coach</span> Prenatal Training System for{" "}
          <span className="text-rose" data-id="element-145" data-mp="2bqpljjtevkj9">Fitness Professionals</span>
        </h1>

        <MockupLink className="mx-auto mt-6 max-w-[240px] md:max-w-[300px]" data-id="element-146" data-mp="26zzg66kzjhok" />

        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-navy/85" data-id="element-147" data-mp="26xwg0tq4c864">
          Coach prenatal clients with a structured <strong className="text-navy" data-id="element-148" data-mp="1x2b9cia3ujq1">40-week system</strong> including complete workouts, exercises, sets, reps, rest
          periods, RPE, progressions and practical exercise modifications.
        </p>

        <div className="mt-10 grid items-center gap-8 md:grid-cols-[0.9fr_1.1fr]" data-id="element-149" data-mp="1o1wlbb5raqiu">
          <a href={OFFER_HASH} className="mx-auto block w-full max-w-sm overflow-hidden rounded-xl shadow-[0_12px_30px_-18px_rgba(28,47,79,0.5)]" data-id="element-150" data-mp="1ecpy99oqdap7">
            <img src={images.heroTraining} alt="Pregnant client performing a controlled box squat with a professional female coach" className="aspect-[4/3] w-full object-cover" data-id="element-151" data-mp="1ig5vo88mjf2y" />
          </a>

          <div data-id="element-152" data-mp="19eoe0lfkj5c5">
            <div className="border-l-4 border-gold pl-3" data-id="element-153" data-mp="19g91xs7dnq11">
              <p className="font-display text-base font-extrabold uppercase text-navy" data-id="element-154" data-mp="1x4s8o3as3ur0">Prenatal Training Pro 2026</p>
              <p className="text-sm font-semibold text-rose" data-id="element-155" data-mp="222al43o08s3r">5 Professional Volumes + 5 Professional Bonuses</p>
            </div>

            <ul className="mt-6 grid grid-cols-5 gap-2" data-id="element-156" data-mp="1nc38w5olc5bi">
              {benefits.map(({
              label,
              icon: Icon,
              color
            }) => <li key={label} className="flex flex-col items-center text-center" data-id="element-157" data-mp="2g236djgrig4c">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full ring-2 ring-gold/40 ${color}`} data-id="element-158" data-mp="2ktbgyittw7j3">
                    <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-159" data-mp="9djc0eqd9982" />
                  </span>
                  <span className="mt-1.5 text-[10px] font-extrabold uppercase leading-tight text-navy md:text-[11px]" data-id="element-160" data-mp="4g1a38arnu9k">{label}</span>
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-161" data-mp="e4j85hrnvn9i">
              <CtaButton label="Yes! I want the complete system" data-id="element-162" data-mp="e6cip85earms" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}